import { render, staticRenderFns } from "./DefaultShippingAlertModal.vue?vue&type=template&id=788cc242&"
import script from "./DefaultShippingAlertModal.vue?vue&type=script&lang=js&"
export * from "./DefaultShippingAlertModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports